import { Ref, ref } from '@vue/composition-api';
import { useCookies } from '@vueuse/integrations/useCookies';
import { PHOENIX_COOKIE, REDIRECT_TO_PHOENIX_KEY, IS_PHOENIX_USER_KEY } from '@front-app/store/user_constants';
import { CookieSetOptions } from 'universal-cookie';

const COOKIE_OPTIONS: CookieSetOptions = {
	path: '/',
	domain: process.env.VUE_APP_COOKIE_DOMAIN,
};

/**
 * We need to support the old cookie, which can clash with the new one
 */
const OLD_COOKIE_OPTIONS: CookieSetOptions = {
	path: '/',
};

export interface PhoenixCookie {
	setIsPhoenixUser: () => void;
	shouldRedirectToPhoenix: Ref<boolean>;
	toggleRedirectSetting: () => void;
	setRedirectSetting: (newVal: boolean) => void;
}

export const usePhoenixCookie = (): PhoenixCookie => {
	const phoenixCookie = useCookies([PHOENIX_COOKIE]);
	const shouldRedirectToPhoenix = ref(Boolean(phoenixCookie.get(REDIRECT_TO_PHOENIX_KEY)) as boolean);

	const setRedirectSetting = (newVal: boolean) => {
		shouldRedirectToPhoenix.value = newVal;
		phoenixCookie.set(REDIRECT_TO_PHOENIX_KEY, newVal, COOKIE_OPTIONS);
	};
	const toggleRedirectSetting = () => {
		const newVal = !shouldRedirectToPhoenix.value;
		setRedirectSetting(newVal);
	};
	const setIsPhoenixUser = () => {
		phoenixCookie.set(IS_PHOENIX_USER_KEY, true, COOKIE_OPTIONS);
		if (phoenixCookie.get(REDIRECT_TO_PHOENIX_KEY) === undefined) {
			phoenixCookie.set(REDIRECT_TO_PHOENIX_KEY, true, COOKIE_OPTIONS);
		}
	};

	/**
	 * We should be able to remove this in future, but currently some users will be maintaining 2 sets of cookies accidentally.
	 */
	const currentRedirectVal = phoenixCookie.get(REDIRECT_TO_PHOENIX_KEY);
	phoenixCookie.remove(REDIRECT_TO_PHOENIX_KEY, OLD_COOKIE_OPTIONS);
	phoenixCookie.remove(IS_PHOENIX_USER_KEY, OLD_COOKIE_OPTIONS);
	setRedirectSetting(currentRedirectVal);

	return {
		shouldRedirectToPhoenix,
		setIsPhoenixUser,
		toggleRedirectSetting,
		setRedirectSetting,
	};
};
